import { Component, Input, OnInit } from '@angular/core';

@Component({
    selector: 'app-logger-date',
    templateUrl: './logger-date.component.html',
})
export class LoggerDateComponent implements OnInit {
    @Input()
    logDates: any;

    @Input()
    nbDates: number;

    constructor() {}

    ngOnInit(): void {}
}
